// extracted by mini-css-extract-plugin
export default {"modal":"CustomModal_modal__vqvwY","container":"CustomModal_container__dQqBi"};